// Default text for the medication label (ฉลากยา), keyed by billing_type id.
//
// The `billing_type` table has no dosage/indication columns — a medication row
// is only a name and a price — so the label's วิธีใช้ / ข้อบ่งชี้ / คำเตือน come
// from here, VERBATIM. MedLabelDialog is read-only (staff choose which labels to
// print, nothing else), so a wording change is made in this file.
//
// ⚠️ Clinical content. Paracetamol is copied from the clinic's existing label;
// the others are standard adult regimens drafted 2026-10-16, approved by Ram for
// production on 2026-10-17.
//
// A medication billing type added in Xano later and missing here falls back to
// MED_FALLBACK — blank วิธีใช้ — and the dialog refuses to print it until an
// entry is added here.

export const MED_CLINIC = {
  name: 'คลินิกทันตกรรมสไมล์ซีซันส์',
  phone: '02-114-3274',
  line: '@smileseasons.dc',
}

export const MED_DEFAULTS = {
  53: {
    th: 'พาราเซตามอล', unit: 'เม็ด',
    sig: 'รับประทานครั้งละ 1 เม็ด วันละ 3 ครั้ง เช้า-กลางวัน-เย็น หลังอาหาร',
    indication: 'ยาแก้ปวด ลดไข้',
    warning: 'ผู้ใหญ่ไม่ควรกินเกิน 8 เม็ด/วัน และเว้นระยะ 4-6 ชม. หากมีอาการแพ้ยา หรือตับอักเสบให้รีบพบแพทย์ทันที',
  },
  54: {
    th: 'ไอบูโพรเฟน', unit: 'เม็ด',
    sig: 'รับประทานครั้งละ 1 เม็ด วันละ 3 ครั้ง หลังอาหารทันที',
    indication: 'ยาแก้ปวด ลดการอักเสบ',
    warning: 'รับประทานหลังอาหารทันที ห้ามใช้ในผู้แพ้ยา NSAIDs/แอสไพริน โรคกระเพาะ หรือโรคไต หากมีผื่น ปวดท้องรุนแรง ให้หยุดยาและพบแพทย์',
  },
  55: {
    th: 'อะม็อกซีซิลลิน', unit: 'แคปซูล',
    sig: 'รับประทานครั้งละ 1 แคปซูล วันละ 3 ครั้ง เช้า-กลางวัน-เย็น หลังอาหาร',
    indication: 'ยาปฏิชีวนะ รักษาการติดเชื้อ',
    warning: 'รับประทานต่อเนื่องจนหมด ห้ามใช้ในผู้แพ้ยากลุ่มเพนิซิลลิน หากมีผื่น ปากบวม หายใจลำบาก ให้หยุดยาและพบแพทย์ทันที',
  },
  56: {
    th: 'เมโทรนิดาโซล', unit: 'เม็ด',
    sig: 'รับประทานครั้งละ 1 เม็ด วันละ 3 ครั้ง เช้า-กลางวัน-เย็น หลังอาหาร',
    indication: 'ยาปฏิชีวนะ รักษาการติดเชื้อ',
    warning: 'รับประทานต่อเนื่องจนหมด ห้ามดื่มแอลกอฮอล์ระหว่างใช้ยาและ 3 วันหลังหยุดยา อาจมีรสขมในปาก',
  },
  57: {
    th: 'แบคโลเฟน', unit: 'เม็ด',
    sig: 'รับประทานครั้งละ 1 เม็ด วันละ 3 ครั้ง หลังอาหาร',
    indication: 'ยาคลายกล้ามเนื้อ',
    warning: 'อาจทำให้ง่วงซึม เวียนศีรษะ ควรหลีกเลี่ยงการขับขี่ยานพาหนะและดื่มแอลกอฮอล์',
  },
  58: {
    th: 'นาพรอกเซน', unit: 'เม็ด',
    sig: 'รับประทานครั้งละ 1 เม็ด วันละ 2 ครั้ง เช้า-เย็น หลังอาหารทันที',
    indication: 'ยาแก้ปวด ลดการอักเสบ',
    warning: 'รับประทานหลังอาหารทันที ห้ามใช้ในผู้แพ้ยา NSAIDs/แอสไพริน โรคกระเพาะ หรือโรคไต',
  },
  310: {
    th: 'ลอราทาดีน', unit: 'เม็ด',
    sig: 'รับประทานครั้งละ 1 เม็ด วันละ 1 ครั้ง',
    indication: 'ยาแก้แพ้ ลดอาการคัน ผื่น น้ำมูก',
    warning: 'อาจทำให้ง่วงได้เล็กน้อย',
  },
}

export const MED_FALLBACK = { th: '', unit: '', sig: '', indication: '', warning: '' }

export const medDefaults = (billingTypeId) => MED_DEFAULTS[Number(billingTypeId)] || MED_FALLBACK
